module.exports = __webpack_public_path__ + "img/light-rain-button.d8b3a35d.svg";